import { GUEST_PICKER } from '@nocowanie/core/consts';

import { ValueConfig } from '../../../models/common/value.config';
import {
    defaultGuestsPickerTranslation,
    GuestsPickerTranslationModel,
} from '../../../models/guests-picker.translation.model';

interface GuestsPickerConfig {
    totalGuestsCountConfig: ValueConfig<number>;
    roomsConfig: ValueConfig<number>;
    adultsConfig: ValueConfig<number>;
    childrenConfig: ValueConfig<number>;
    childAgeItemConfig: ValueConfig<number>;
    translationData: GuestsPickerTranslationModel;
}

const defaultGuestsPickerConfig: GuestsPickerConfig = {
    totalGuestsCountConfig: {
        min: GUEST_PICKER.CONFIG.TOTAL_GUESTS.MIN,
        max: GUEST_PICKER.CONFIG.TOTAL_GUESTS.MAX,
    },
    roomsConfig: { min: 1, max: 15, default: 1 },
    adultsConfig: {
        min: GUEST_PICKER.CONFIG.ADULTS.MIN,
        max: GUEST_PICKER.CONFIG.ADULTS.MAX,
        default: 2,
    },
    childrenConfig: {
        min: GUEST_PICKER.CONFIG.CHILDREN.MIN,
        max: GUEST_PICKER.CONFIG.CHILDREN.MAX,
        default: 0,
    },
    childAgeItemConfig: {
        min: GUEST_PICKER.CONFIG.CHILD_AGE.MIN,
        max: GUEST_PICKER.CONFIG.CHILD_AGE.MAX,
    },
    translationData: defaultGuestsPickerTranslation,
};

export { type GuestsPickerConfig, defaultGuestsPickerConfig };
